import { render, staticRenderFns } from "./LegalDocumentContent_hPspqE.vue?vue&type=template&id=44ee1b57&scoped=true&"
var script = {}
import style0 from "./LegalDocumentContent_hPspqE.vue?vue&type=style&index=0&id=44ee1b57&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ee1b57",
  null
  
)

export default component.exports